import { patchDelivery, getDelivery } from "api/deliveries/calls";
import { createAsyncUpdateConnector } from "utilities";
import { createPrimitiveHook } from "hooks/createPrimitiveHook";

export const useUpdateDelivery = createAsyncUpdateConnector(patchDelivery);
export const useDelivery = createPrimitiveHook(getDelivery);
